import { singularityFieldConfig } from "./singularityFieldConfig";

export type OpticalLensingConfig = {
  influenceRadiusWorld: number;
  innerRadiusRatio: number;
  pointMaxShiftPx: number;
  orbitalMaxShiftPx: number;
  connectorMaxShiftPx: number;
  falloffExponent: number;
};

export const opticalLensingConfig: OpticalLensingConfig = {
  influenceRadiusWorld: singularityFieldConfig.opticalInfluenceRadius,
  innerRadiusRatio: 0.22,
  pointMaxShiftPx: 20,
  orbitalMaxShiftPx: 16,
  connectorMaxShiftPx: 22,
  falloffExponent: 1.45,
};
